import React from "react";
import SidebarSubHeading from "./SidebarSubHeading";
import SidebarLabel from "./SidebarLabel";
import type { ServiceType, ServiceTypeCategories } from "~/types";
import { useSearch } from "~/context/SearchContext";

type Props = {
  serviceTypes: ServiceType[];
  serviceTypeCategories: ServiceTypeCategories;
};

const ServiceTypeSection: React.FC<Props> = ({
  serviceTypes,
  serviceTypeCategories,
}) => {
  const {
    conditions: selectedConditions,
    addCondition: handleAddCondition,
    removeCondition: handleSubCondition,
  } = useSearch();

  const renderServiceTypeCategory = (categoryKey: string) => {
    const category = serviceTypeCategories[categoryKey];
    const typesForCategory = serviceTypes.filter(
      (type) => type.service_type_category_id === category.id
    );

    return (
      <React.Fragment key={categoryKey}>
        <SidebarSubHeading text={category.name} />
        <SidebarLabel
          text="全て選択"
          type="service_type_ids"
          value={typesForCategory.map((type) => type.id)}
        />
        {typesForCategory.map((type) => (
          <SidebarLabel
            key={type.id}
            text={type.name}
            type="service_type_ids"
            value={type.id}
          />
        ))}
      </React.Fragment>
    );
  };

  return (
    <div className="[&>div]:my-2">
      {Object.keys(serviceTypeCategories).map(renderServiceTypeCategory)}
    </div>
  );
};

export default ServiceTypeSection;
